export enum Environment {
  Development = "local",
  Staging = "staging",
  Production = "production",
}
